var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-toast-container"},[_c('div',{class:['gc-toast', `toast-${_vm.type}`],attrs:{"role":"alert","aria-live":"assertive"}},[_c('div',{staticClass:"gc-toast-header"},[_c('div',{staticClass:"toast-message"},[_c('p',[_vm._v(_vm._s(_vm.message))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }